// extracted by mini-css-extract-plugin
module.exports = {"post":"post-module--post--3ESLj","title":"post-module--title--hTIc5","info":"post-module--info--3HbAq","twitter":"post-module--twitter--1ejE3"};